import { render, staticRenderFns } from "./TurnBox.html?vue&type=template&id=5fc342fb&external"
import script from "./TurnBox.ts?vue&type=script&lang=ts&external"
export * from "./TurnBox.ts?vue&type=script&lang=ts&external"
import style0 from "./TurnBox.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports